import { Notyf } from "notyf";
import 'notyf/notyf.min.css';

export function showSuccessNotification(message) {
    new Notyf().success({
        message: message,
        position: {
            x: 'center',
            y: 'top'
        }
    });
}

export function showWarningNotification(message) {
    const notyf = new Notyf({
        duration: 4000,
        types: [
            {
                type: 'warning',
                background: 'orange',
                icon: false
            }
        ]
    });

    notyf.open({
        type: 'warning',
        message: message,
        position: {
            x: 'center',
            y: 'top'
        }
    });
}

export function showErrorNotification(error) {
    if (error.status === 400) {
        showValidationProblemNotification(error.data.errors)
    }
    else {
        showInternalServerErrorNotification()
    }
}

function showValidationProblemNotification(errors) {
    let message = "";
    for (const [, value] of Object.entries(errors)) {
        message += value
    }

    showWarningNotification(message);
}

function showInternalServerErrorNotification() {
    new Notyf().error({
        message: 'Wystąpił błąd. Proszę spróbować ponownie lub skontaktować się z administratorem.',
        position: {
            x: 'center',
            y: 'top'
        }
    });
}
